import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { PhoneInput } from 'react-international-phone';
// eslint-disable-next-line import/no-unresolved
import 'react-international-phone/style.css';
import { Link, useLocation } from 'react-router-dom';

import allocabLogo from '../assets/images/allocab-logo.png';
import { BaseButton } from '../components/button/BaseButton';
import { PrimaryButton } from '../components/button/PrimaryButton';
import { constants } from '../constants';
import { useAuth } from '../hooks/useAuth';
import { t } from '../services/translation/translation';
import { generateRandomPassword } from '../utils/auth';

export const SubscribeRoute = () => {
  const location = useLocation();
  const { userFromFacebook } = location.state || {};
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    message: '',
    color: '',
  });
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberCountry, setPhoneNumberCountry] = useState('FR');
  const [lastName, setLastName] = useState(userFromFacebook?.last_name);
  const [firstName, setFirstName] = useState(userFromFacebook?.first_name);
  const [email, setEmail] = useState(userFromFacebook?.email);
  const facebookId = userFromFacebook?.userID;
  const [company, setCompany] = useState({
    name: '',
    street: '',
    zipCode: '',
    city: '',
    country: 'FR',
    phoneNumberCountry: 'FR',
    phoneNumber: '',
    email: '',
  });
  const { signupMutation } = useAuth();
  useEffect(() => {
    if (userFromFacebook) {
      setPassword(generateRandomPassword());
    }
  }, [userFromFacebook]);
  useEffect(() => {
    if (
      password.match(/[0-9]/g) &&
      password.match(/[A-Z]/g) &&
      password.match(/[a-z]/g) &&
      password.match(/[^a-zA-Z\d]/g) &&
      password.length >= 8
    ) {
      setPasswordValidation({ message: t('signup.strongpassword'), color: 'success' });
    } else {
      setPasswordValidation({ message: t('signup.weakpassword'), color: 'error' });
    }
  }, [password]);
  const handlePhoneChange = (phone: string) => {
    setPhoneNumberCountry(phoneNumberCountry);
    setPhoneNumber(phone);
    if (constants.isHotels) {
      handlePhoneCompanyChange(phone);
    }
  };

  const handlePhoneCompanyChange = (phone: string) => {
    setCompany({
      ...company,
      phoneNumber: phone,
      phoneNumberCountry: phoneNumberCountry,
    });
  };

  const handleEmailUpdate = (email: string) => {
    setEmail(email);
    if (constants.isHotels) {
      setCompany({ ...company, email });
    }
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const applicationForm = document.getElementById('subscribe') as HTMLFormElement;
    e.preventDefault();
    if (applicationForm?.checkValidity()) {
      e.preventDefault();
      signupMutation.mutate({
        email,
        password,
        firstName,
        lastName,
        phoneNumber,
        phoneNumberCountry,
        status: 'CORPORATE',
        gender: 'MALE',
        emailCommunications: true,
        company,
        facebookId,
      });
    } else {
      applicationForm?.reportValidity();
    }
  };

  return (
    <div className="h-[calc(100vh_-_3rem)] overflow-y-auto">
      <Helmet>
        <title>{t('subscribe-route.meta-title')}</title>
      </Helmet>
      <video
        className="hidden md:block fixed bottom-0 right-0 z-[-100] min-w-full min-h-full w-auto h-auto object-cover"
        preload="none"
        autoPlay
        loop
        muted
      >
        <source
          src="//storage.googleapis.com/allocab_prod_apps/webapp/media/stock-footage-out-of-focus-city-traffic-at-night-car-headlights-and-tail-lights-out-of-focus.mov"
          type="video/mp4"
        />
      </video>

      <div className="flex min-h-full flex-col justify-center pb-12 sm:px-6 lg:px-8">
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-lg">
          <div className="bg-background py-8 px-2 shadow sm:px-10 md:opacity-90">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <img className="mx-auto h-16 w-auto" src={allocabLogo} alt="allocab" />
              <h2 className="my-6 text-center text-3xl font-bold tracking-tight ">
                {constants.isHotels ? t('signup.hotels.welcome') : t('signup.welcome')}
              </h2>
            </div>
            <form id="subscribe" onSubmit={onSubmit}>
              <div className="">
                <div className="flex flex-row justify-between">
                  <div className="w-full p-1 mb-2">
                    <label htmlFor="firstName" className="block text-sm font-medium leading-6 ">
                      {t('signup.firstname')}
                    </label>
                    <div className="mt-1">
                      <input
                        value={firstName}
                        onChange={e => setFirstName(e.target.value)}
                        placeholder="jean"
                        id="firstName"
                        name="firstName"
                        type="text"
                        required
                        className="block w-full border-0 py-1.5 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                  <div className="w-full p-1 mb-2">
                    <label htmlFor="lastName" className="block text-sm font-medium leading-6 ">
                      {t('signup.lastname')}
                    </label>
                    <div className="mt-1">
                      <input
                        value={lastName}
                        onChange={e => setLastName(e.target.value)}
                        placeholder="dupont"
                        id="lastName"
                        name="lastName"
                        type="text"
                        required
                        className="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full p-1 mb-2">
                  <label htmlFor="phone" className="block text-sm font-medium leading-6 ">
                    {t('signup.phone')}
                  </label>
                  <div className="mt-1">
                    <PhoneInput
                      inputStyle={{ border: '0', borderRadius: '0' }}
                      className="w-full"
                      countrySelectorStyleProps={{ buttonStyle: { width: '55px', borderRadius: '0' } }}
                      inputClassName="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                      defaultCountry="fr"
                      forceDialCode={true}
                      value={phoneNumber}
                      placeholder="6 12 34 56 78"
                      onChange={phone => handlePhoneChange(phone)}
                    />
                  </div>
                </div>

                <div className="w-full p-1 mb-2">
                  <label htmlFor="email" className="block text-sm font-medium leading-6 ">
                    {t('signup.email')}
                  </label>
                  <div className="mt-1">
                    <input
                      value={email}
                      onChange={e => handleEmailUpdate(e.target.value)}
                      placeholder="jean@allocab.com"
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      className="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                {!userFromFacebook ? (
                  <>
                    <div className="w-full p-1 mb-2">
                      <label htmlFor="password" className="block text-sm font-medium leading-6 ">
                        {t('signup.password')}
                      </label>
                      <div className="mt-1 relative">
                        <input
                          id="password"
                          name="password"
                          type={showPassword ? 'text' : 'password'}
                          value={password}
                          onChange={e => setPassword(e.target.value)}
                          placeholder="************"
                          autoComplete="current-password"
                          required
                          className="block w-full border-0 py-1.5 pr-9 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                        />
                        <div
                          className="cursor-pointer absolute inset-y-0 right-0 py-1.5 pr-3 flex items-center text-sm leading-5"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <svg
                              className="h-4 text-text_secondary"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 576 512"
                            >
                              <path
                                fill="currentColor"
                                d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                              ></path>
                            </svg>
                          ) : (
                            <svg
                              className="h-4 text-text_secondary"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 640 512"
                            >
                              <path
                                fill="currentColor"
                                d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                              ></path>
                            </svg>
                          )}
                        </div>
                      </div>
                      <span className={`text-${passwordValidation.color} italic text-xs`}>
                        {passwordValidation.message}
                      </span>
                    </div>
                  </>
                ) : null}

                <hr className="m-4" />

                <div className="w-full p-1 mb-2">
                  <label htmlFor="companyName" className="block text-sm font-medium leading-6 ">
                    {constants.isHotels ? t('signup.hotels.companyname') : t('signup.companyname')}
                  </label>
                  <div className="mt-1">
                    <input
                      value={company.name}
                      onChange={e => setCompany({ ...company, name: e.target.value })}
                      placeholder="hotel"
                      id="companyName"
                      name="companyName"
                      type="text"
                      required
                      className="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div className="w-full p-1 mb-2">
                  <label htmlFor="companyAddress" className="block text-sm font-medium leading-6 ">
                    {constants.isHotels ? t('signup.hotels.companyaddress') : t('signup.companyaddress')}
                  </label>
                  <div className="mt-1">
                    <input
                      value={company.street}
                      onChange={e => setCompany({ ...company, street: e.target.value })}
                      placeholder="12 rue de la paix"
                      id="companyAddress"
                      name="companyAddress"
                      type="text"
                      required
                      className="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div className="flex flex-row justify-between">
                  <div className="w-full p-1 mb-2">
                    <label htmlFor="companyZipCode" className="block text-sm font-medium leading-6 ">
                      {t('signup.companyzipCode')}
                    </label>
                    <div className="mt-1">
                      <input
                        value={company.zipCode}
                        onChange={e => setCompany({ ...company, zipCode: e.target.value })}
                        placeholder="75008"
                        id="companyZipCode"
                        name="companyZipCode"
                        type="text"
                        required
                        className="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                  <div className="w-full p-1 mb-2">
                    <label htmlFor="companyCity" className="block text-sm font-medium leading-6 ">
                      {t('signup.companycity')}
                    </label>
                    <div className="mt-1">
                      <input
                        value={company.city}
                        onChange={e => setCompany({ ...company, city: e.target.value })}
                        placeholder="Paris"
                        id="companyCity"
                        name="companyCity"
                        type="text"
                        required
                        className="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                </div>
                {constants.isHotels ? (
                  <></>
                ) : (
                  <>
                    {' '}
                    <div className="w-full p-1 mb-2">
                      <label htmlFor="companyPhone" className="block text-sm font-medium leading-6 ">
                        {t('signup.companyphone')}
                      </label>
                      <div className="mt-1">
                        <PhoneInput
                          inputStyle={{ border: '0', borderRadius: '0' }}
                          className="w-full"
                          countrySelectorStyleProps={{ buttonStyle: { width: '55px', borderRadius: '0' } }}
                          inputClassName="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                          defaultCountry="fr"
                          forceDialCode={true}
                          value={company.phoneNumber}
                          placeholder="1 23 45 67 89"
                          onChange={phone => handlePhoneCompanyChange(phone)}
                        />
                      </div>
                    </div>
                    <div className="w-full p-1 mb-2">
                      <label htmlFor="companyEmail" className="block text-sm font-medium leading-6 ">
                        {t('signup.companyemail')}
                      </label>
                      <div className="mt-1">
                        <input
                          value={company.email}
                          onChange={e => setCompany({ ...company, email: e.target.value })}
                          placeholder="contact@mycompany.com"
                          id="companyEmail"
                          name="companyEmail"
                          type="email"
                          required
                          className="block w-full border-0 py-1.5  shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </form>
            <hr className="m-4" />
            <div className="mb-4">
              <p className="text-sm text-center">
                {t('signup.clicking')}{' '}
                <a className="text-cta" target="blank" href="https://www.allocab.com/conditions-generales-de-service">
                  {t('signup.general-condition')}
                </a>{' '}
                {t('signup.all-field')}{' '}
                <a className="text-cta" target="blank" href="https://www.allocab.com/protection-donnees-personnelles">
                  {t('signup.learn-more')}.
                </a>
              </p>
            </div>
            <div>
              <PrimaryButton className="w-full" type="submit" form="subscribe" isLoading={signupMutation.isLoading}>
                {t('signup.register')}
              </PrimaryButton>
            </div>

            <div className="mt-6">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t" />
                </div>
              </div>
              <div className="flex justify-center">
                <span className="bg-background px-2 mt-5">{t('signup.account')}</span>
                <Link className="text-cta font-bold mt-5 hover:opacity-80" to={`/login`}>
                  {t('signup.login')}
                </Link>
              </div>
            </div>
            <div className="mt-6">
              <p className="text-xs text-center text-text_secondary">
                {t('signup.responsible')}{' '}
                <a className="text-cta" target="blank" href="https://www.allocab.com/conditions-generales-de-service">
                  {t('signup.here')}.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
